import { render, staticRenderFns } from "./RoosterEditor.vue?vue&type=template&id=5ca06105&"
import script from "./RoosterEditor.vue?vue&type=script&lang=js&"
export * from "./RoosterEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports